import * as Layout from '@zocdoc/components/src/Layout';
import { breakpoint } from '@zocdoc/components/src/grid';
import { getLogoSizingAtBreakpoint } from '@zocdoc/components/src/themes/helpers';
import styled, { css } from 'styled-components';
import { FontFamily } from '@zocdoc/components/src/typography';

const Toggles = styled.div`
    color: ${p => p.theme.header.textColor};
    cursor: pointer;
    font: 13px ${FontFamily.SharpSansSemibold};
    box-sizing: border-box;
    display: flex;
    line-height: ${p => { const h = getLogoSizingAtBreakpoint(p.theme, 'xxsmall').height; return h ? `${h}px` : 1; }};
    position: absolute;
    right: ${Layout.PAGE_X_AXIS_PADDING_BY_BREAKPOINT.XXSMALL}px;
    top: ${Layout.HEADER_Y_AXIS_PADDING}px;

    ${breakpoint.xsmall} {
        ${p => { const h = getLogoSizingAtBreakpoint(p.theme, 'xsmall').height; return h ? css`line-height: ${h}px;` : ''; }}
        right: ${Layout.PAGE_X_AXIS_PADDING_BY_BREAKPOINT.XSMALL}px;
    }

    ${breakpoint.small} {
        right: ${Layout.PAGE_X_AXIS_PADDING_BY_BREAKPOINT.SMALL}px;
    }

    ${breakpoint.medium} {
        display: none;
    }
`;

export default Toggles;
